export default __webpack_public_path__ + "static/media/org_placeholder.0f896b7a.svg";